import {fetchHelp} from '../../../services/form/form';
import {mapHelpData} from '../utils/popover-utils';
import {patchColumnHelpContent} from '../utils/help';
import {helpMessage, Column} from '../../../stores/Form/Column';

const DEFAULT_OPTIONS = {
    handleMessages: false
};

export const getFieldHelp = async (Fname: string, column: Column) => {
    if (column.helpMessage) return column.helpMessage;
    const response = await fetchHelp({Fname, ColName: column.Name}, DEFAULT_OPTIONS);
    const helpData = mapHelpData(response.Messages[0]);
    const patchHelpData = {...helpData, content: patchColumnHelpContent(helpData?.content)};
    column.setHelpMessage(patchHelpData as helpMessage);
    return patchHelpData;
};

export const getFormHelpText = async (Fname: string) => {
    const res = await fetchHelp({Fname}, DEFAULT_OPTIONS);
    return mapHelpData(res.Messages[0]);
};

export const getActionHelp = async (Exec: number) => {
    const res = await fetchHelp({Exec}, DEFAULT_OPTIONS);
    return mapHelpData(res.Messages[0]);
};
